import React from 'react';
import IntlMessages from 'util/IntlMessages';
function index(props) {
    return (
        <div>
            <IntlMessages id="Activities"/>
        </div>
    );
}

export default index;